// extracted by mini-css-extract-plugin
export default {"wrapper":"_B-z","viewport":"aC-z","container":"bC-z","slide":"cC-z"};